<div class="grid justify-items-start sm:justify-items-center xl:justify-items-end">
  <div class="w-fit min-w-max overflow-hidden rounded-xl bg-gray-50">
    <mat-paginator
      [length]="length"
      [pageSize]="pageSize"
      [pageIndex]="pageIndex"
      [pageSizeOptions]="pageSizeOptions"
      [showFirstLastButtons]="showFirstLastButtons"
      [hidePageSize]="hidePageSize"
      [disabled]="disabled"
      (page)="onPageChange($event)"
    >
    </mat-paginator>
  </div>
</div>
